// Tipo TypeScript inferido del schema
import { z } from "zod";

export const RegisterYourPropertyFormSchema = z.object({
  name: z
    .string({ required_error: "Este campo es requerido" })
    .min(1, { message: "Este campo es requerido" })
    .min(2, { message: "Este campo debe tener al menos 2 caracteres" })
    .max(50, { message: "Este campo no puede exceder los 50 caracteres" }),
  lastName: z
    .string({ required_error: "Este campo es requerido" })
    .min(1, { message: "Este campo es requerido" })
    .min(2, { message: "Este campo debe tener al menos 2 caracteres" })
    .max(50, { message: "Este campo no puede exceder los 50 caracteres" }),
  email: z
    .string({ required_error: "Este campo es requerido" })
    .min(1, { message: "Este campo es requerido" })
    .email({ message: "Este campo no es válido" })
    .max(100, { message: "Este campo no puede exceder los 100 caracteres" }),
  phone: z.string().min(1, { message: "El phone es requerido" }),
  message: z
    .string({ required_error: "Este campo es requerido" })
    .min(1, { message: "Este campo es requerido" })
    .max(1500, { message: "Este campo no puede exceder los 1500 caracteres" }),
  companyName: z
    .string({ required_error: "Este campo es requerido" })
    .min(2, { message: "Este campo debe tener al menos 2 caracteres" })
    .max(50, { message: "Este campo no puede exceder los 50 caracteres" }),
  tradeName: z
    .string({ required_error: "Este campo es requerido" })
    .min(2, { message: "Este campo debe tener al menos 2 caracteres" })
    .max(50, { message: "Este campo no puede exceder los 50 caracteres" }),
  positionCompany: z
    .string({ required_error: "Este campo es requerido" })
    .min(2, { message: "Este campo debe tener al menos 2 caracteres" })
    .max(50, {
      message: "Este campo no puede exceder los 50 caracteres",
    }),
  webCompany: z
    .string({ required_error: "Este campo es requerido" })
    .min(2, { message: "Este campo debe tener al menos 2 caracteres" })
    .max(50, { message: "Este campo no puede exceder los 50 caracteres" }),
  isTokenizeProject: z.boolean({
    required_error: "Este campo es requerido",
    invalid_type_error: "Este campo debe ser un booleano",
  }),

  resourcesProject: z.enum(["pre-venta", "deuda", "inversion"], {
    errorMap: () => ({
      message: "Este campo es requerido",
    }),
  }),
});
